import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// info-2.twig
import React from 'react';
import { Content, contextualSpaces, Headline } from '@miro-site/components_utils';
import { Box, Container, Section } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FrameWrapperStyles = {
  marginTop: [28, 40],
  height: [280, 580],
  width: '100%'
};

var OneColumnEmbed = function OneColumnEmbed(_ref) {
  var headline = _ref.headline,
      content = _ref.content,
      embed_id = _ref.embed_id,
      sectionId = _ref.sectionId;
  return /*#__PURE__*/_jsx(Section, {
    id: sectionId,
    "data-place": "Embed Section",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
        size: "mid",
        tag: "h2",
        align: headline.align || 'left'
      })), content && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, content), {}, {
        textProps: {
          $styles: {
            marginTop: contextualSpaces.textSpaces.afterHeadline.medium
          }
        }
      })), embed_id && /*#__PURE__*/_jsx(Box, {
        $styles: FrameWrapperStyles,
        children: /*#__PURE__*/_jsx("iframe", {
          src: "https://miro.com/app/embed/".concat(embed_id, "/?autoplay=yep"),
          width: "100%",
          height: "100%",
          frameBorder: "0",
          scrolling: "no",
          title: typeof headline.text === 'string' ? headline.text : embed_id
        })
      })]
    })
  });
};

export default OneColumnEmbed;